export default function totalCalculation({
  cruisePurchases,
  discount,
  otherCost,
}) {
  let tempTotal: number = 0;
  tempTotal = cruisePurchases.reduce((prev, curr) => {
    let tempSchedulePrice = 0;
    if (curr.isGroupedPrice) {
      tempSchedulePrice +=
        (curr.cruisePurchaseDetails?.[0]?.basicFare || 0) +
        (curr.cruisePurchaseDetails?.[0]?.portCharge || 0) +
        (curr.cruisePurchaseDetails?.[0]?.tax || 0) +
        (curr.cruisePurchaseDetails?.[0]?.tipping || 0);
    } else {
      tempSchedulePrice += curr.cruisePurchaseDetails.reduce(
        (prev, curr) =>
          prev +
          (curr.basicFare || 0) +
          (curr.portCharge || 0) +
          (curr.tax || 0) +
          (curr.tipping || 0),
        0,
      );
    }

    tempSchedulePrice += curr.cruisePurchaseAddOns.reduce(
      (prevAddon, currAddon) => prevAddon + (currAddon.price || 0),
      0,
    );
    return prev + tempSchedulePrice;
  }, 0);

  tempTotal -= discount || 0;
  tempTotal += otherCost || 0;
  return tempTotal;
}
